import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@bya/auth/services/authentication.service';


@Component({
  selector: 'logout-callback',
  templateUrl: './logout-callback.component.html',
    styleUrls: ['./logout-callback.component.scss']
})
export class LogoutCallBackComponent implements OnInit {

  error : boolean;

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.authService.completeLogout();      
    this.router.navigate(['/']);    //home
  }
}
